import React, { useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
export function Navbar() {
  const {
    scrollY
  } = useScroll();
  const [isScrolled, setIsScrolled] = useState(false);
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 1,
    ease: [0.2, 0.65, 0.3, 0.9]
  }} className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${isScrolled ? 'bg-forest/95 backdrop-blur-sm shadow-lg py-4' : 'bg-transparent py-6'}`} data-id="element-102">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-103">
        <a href="#" className="block" data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/vEZmUYWeeMJzqWvRht4QDT/The_botanical_gallery_Logo_sin_fondo.png" alt="The Botanical Gallery" className={`h-16 md:h-20 lg:h-24 w-auto object-contain transition-all duration-500 ${isScrolled ? 'opacity-100' : 'opacity-90'}`} data-id="element-105" />
        </a>

        <motion.a href="#contacto" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="bg-goldBright hover:bg-goldBrightDark text-white font-bold rounded-full px-8 py-3 uppercase tracking-widest text-xs md:text-sm transition-colors duration-300 shadow-md hover:shadow-lg [text-shadow:0_1px_2px_rgba(0,0,0,0.35)]" data-id="element-106">
          Contáctanos ahora
        </motion.a>
      </div>
    </motion.nav>;
}